import AdvancedSettings from './AdvancedSettings'

export default AdvancedSettings
